export default function (items = [], key = 'id') {
  if (!items.length) {
    if (Array.isArray(items)) {
      return {};
    }

    return items;
  }

  function reducer(result, item) {
    // eslint-disable-next-line no-param-reassign
    result[item[key]] = item;

    return result;
  }

  return items.reduce(reducer, {});
}
